import {connect} from "react-redux";
import ParkingActivitySave from "./Save";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";
import {getPendingActivity} from "../../../../service/Parking/action";
import {saveActivity, markAttendance} from "../../../../service/Parking/action";
import {isCheckout} from "../../../../service/CarService/action";
import {accountById} from "../../../../service/Valet/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    senior:state.Dealer.senior,
    saveActivityRes:state.Parking.saveActivityRes,
    pendingActivity:state.Valet.pendingActivity,
    isCheckoutDetails:state.CarService.isCheckout,
    attendance:state.Parking.attendance,
    accountDetailsByIdData: state.Valet.accountById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            activityTypes,
            getSenior,
            saveActivity,
            getPendingActivity,
            isCheckout,
            markAttendance,
            accountById,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ParkingActivitySave);
